import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from "@angular/router";
import { RegistrationService } from '../../registration.service';

@Component({
  selector: 'app-view-sainik',
  templateUrl: './view-sainik.component.html',
  styleUrls: ['./view-sainik.component.css']
})
export class ViewSainikComponent implements OnInit {
  service_Id:any;
  title="Sainik View";
  data: any;
  S: any={};
  SR: any={};
  SA : any={};
  SD: any[];
  SB: any={};
  SP: any={};
  SBC: any={};
  SU: any[];
  photoURL: any;

  constructor(private service: RegistrationService,private activatedRoute:ActivatedRoute) { }

  ngOnInit() {
    this.activatedRoute.paramMap.subscribe((params) => {
      this.service_Id = params.get("serviceno"); //+ string to number
    });

    console.log('service no :' +this.service_Id)
    this.GetSainikCompleteDetails(this.service_Id)
  }

  printForm(): void {
    let printContents, popupWin;
    printContents = document.getElementById('print-section').innerHTML;   
    popupWin = window.open('', '_blank', 'top=0,left=0,height=700,width=700');
    popupWin.document.open();
    popupWin.document.write(`
      <html>
        <head>
          <title>${this.service_Id}</title>         
          <style>
          .form{
            background: #f2f2f2;
            border: 1px solid #ccc;
            padding:20px;
        }  
              
        .awardtable{
            margin-top: -10px;
        }
        
        .awardtable td{
            padding:5px;
            font-size:15px;
        }
        
        .form .container{
            background: #fff;
        }      
        
        .padding0{
            padding:0;
        }
        
        .form-label{
            /* font-size:12px;
            display: block;
            padding:10px 0px 0px 0px;
            color:#aaa; */
            font-size: 16px;
            width: 44%;
            display: inline-block;
            color: #797878;
        }
        
        .data{
            font-size: 16px;
            display: inline-block;
            width: 50%;
            padding: 5px;
            vertical-align: middle;
        }   
        
        
        .sub-title{
            font-size:18px;
            padding-left:20px;
            text-decoration: underline;
        }
        
        .row{
            padding:10px;
        }
        
        .row:nth-child(odd){
            background:#ffffff;
        }
        
        .table-header{
            background: grey;
            color: #fff;
        }
        
        .highlight-row{
            background:#f1ecec;
        }
        
        .sticky-back{
            position: fixed;
            left: 65px;
            top: 165px;
            z-index: 100;
        }
        
          </style>
        </head>
    <body onload="window.print();window.close()">${printContents}</body>
      </html>`
    );
    popupWin.document.close();
}

  GetSainikCompleteDetails(SR_ServiceNo)
  {   
      this.data = this.service.getRegSainikCompleteDetails(SR_ServiceNo);    
      this.data.subscribe(
      (response:any) => {        
        this.S=response;
        this.SR=response.SainikRegistration;
        //console.log('service no :' +JSON.stringify(this.SR))
        this.SA=response.SainikAwards;
        this.SD=response.SainikDependents;

         //rohit
         this.SD=response.SainikViewDependents;
        // console.log('doc data :' +JSON.stringify(response.SainikViewDependents.SainikDependentsDocument)) 

        if(response.SainikBankDetails!=null){
        this.SB=response.SainikBankDetails;
        }
        if(response.SainikPension!=null){
        this.SP=response.SainikPension;
        }
        if(response.SainikBattleCasualty!=null){
        this.SBC=response.SainikBattleCasualty;
        }
        this.SU=response.SainikUploads;
        if(this.SR.SR_OA_Pincode==0||this.SR.SR_OA_Pincode==undefined)
        this.SR.SR_OA_Pincode=null;
         if(this.SR.SR_Pincode==0||this.SR.SR_Pincode==undefined)
         this.SR.SR_Pincode=null;
         if(this.SR.SR_PA_Pincode==0||this.SR.SR_PA_Pincode==undefined)
         this.SR.SR_PA_Pincode=null;
            for(let i=0;i<this.SU.length;i++){
                        if(this.SU[i].DocumentTypes.IsSelected==1){
                          this.SU[i].DocumentTypes.IsSelected=true; 
         }       
       if(this.SU[i].DocumentTypes.DT_Name=='Photo'){
        this.photoURL=this.SU[i].ImagePath;
        //console.log("photo URL :" +this.photoURL);
       }
       }
      }
      );
   

  }

}



// WEBPACK FOOTER //
// ./src/app/sainik-registration/view-sainik/view-sainik.component.ts